import React, { useState, useEffect } from 'react';
import { Link } from 'react-router';
import { LoadingSpinner } from '../common';
import { fetchAktuellesPosts } from '../../services/aktuellesService';
import { ROUTES, SECTION_IDS } from '../../constants/routes';

const BASE_URL = (typeof process !== 'undefined' && process.env?.REACT_APP_GALLERY_PUBLIC_BASE_URL) || 'https://kickereck-gallery-prod.s3.eu-central-1.amazonaws.com';

function resolvePhotoUrl(key) {
    if (!key || typeof key !== 'string') return null;
    if (key.startsWith('http')) return key;
    const base = BASE_URL.replace(/\/$/, '');
    return base + (key.startsWith('/') ? key : '/' + key);
}

function stripMarkdownExcerpt(text = '', maxLen = 160) {
    const plain = text
        .replace(/!\[.*?\]\(.*?\)/g, '')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/#{1,6}\s/g, '')
        .replace(/[*_`~>]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    return plain.length > maxLen ? plain.slice(0, maxLen).trimEnd() + '…' : plain;
}

const AktuellesTeaser = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        fetchAktuellesPosts({ limit: 3 })
            .then((result) => { if (!cancelled) setPosts(result.posts || []); })
            .catch(() => {})
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    if (loading) {
        return (
            <div id={SECTION_IDS.AKTUELLES} className="text-center" style={{ padding: '80px 0' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (posts.length === 0) return null;

    return (
        <div id={SECTION_IDS.AKTUELLES}>
            <div className="container">
                <div className="section-title text-center">
                    <h2>Aktuelles</h2>
                    <p>Was gibt&apos;s Neues im KickerEck?</p>
                </div>

                <div className="row">
                    {posts.map((post) => {
                        const photoUrl = resolvePhotoUrl(post.fotos?.[0]);
                        const dateLabel = post.datum
                            ? new Date(post.datum).toLocaleDateString('de-DE', {
                                day: '2-digit', month: 'long', year: 'numeric',
                            })
                            : null;

                        return (
                            <div key={post.id} className="col-md-4 aktuelles-card-col">
                                <div className="aktuelles-card">
                                    {photoUrl && (
                                        <div className="aktuelles-card-img-wrap">
                                            <img src={photoUrl} alt={post.titel} loading="lazy" />
                                        </div>
                                    )}
                                    <div className="aktuelles-card-body">
                                        {dateLabel && (
                                            <span className="aktuelles-card-date">{dateLabel}</span>
                                        )}
                                        <h3 className="aktuelles-card-title">{post.titel}</h3>
                                        <p className="aktuelles-card-excerpt">
                                            {stripMarkdownExcerpt(post.text)}
                                        </p>
                                        <Link
                                            to={ROUTES.AKTUELLES}
                                            className="aktuelles-card-read-more"
                                            data-testid="aktuelles-teaser-card-link"
                                        >
                                            Weiterlesen &rarr;
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="text-center aktuelles-teaser-cta">
                    <Link
                        to={ROUTES.AKTUELLES}
                        className="btn btn-custom btn-lg"
                        data-testid="aktuelles-teaser-link"
                    >
                        Alle Beiträge
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AktuellesTeaser;
